// src/api/fetchConfig.js
import request from '@/utils/request'

export function getLoginConfig() {
  return request({
    url: '/base/user/getLoginConfig',
    method: 'GET'
  })
}
export function fetchConfig(category) {
  return request({
    url: '/base/sys_conf_item/portal/list',
    method: 'GET',
    params: {
      category: category
    }
  })
}

export async function fetchAllConfigs() {
  const clientEndConfig = await fetchConfig('clientEnd')
  const manageEndConfig = await fetchConfig('manageEnd')
  return {
    clientEnd: clientEndConfig.data || [],
    manageEnd: manageEndConfig.data || []
  }
}
